/*
 * fn: isValidRoute
 *
 * Whether every required segment of the route's template is filled
 *
 */
import { getRouteConfig, isRouteParamType, type RouteType } from '@/defs/route'

import { buildRouteParam } from './buildRouteParam'
import { getRouteTemplateSegments } from './getRouteTemplateSegments'

export const isValidRoute = (route: RouteType) =>
  getRouteTemplateSegments(getRouteConfig(route.section).template)
    .filter(({ type }) => type === 'required')
    .every(({ value }) => isRouteParamType(value) && !!buildRouteParam(value, route[value]))
